import { Anchor, Phone, Mail } from "lucide-react";
import { NAV_LINKS } from "@/lib/data";

export default function Footer() {
  return (
    <footer id="partners" className="relative bg-[#0B0F14] border-t border-white/10 overflow-hidden">
      {/* watermark */}
      <div className="pointer-events-none absolute -bottom-6 left-0 right-0 text-center select-none">
        <span className="font-display font-black uppercase text-[16vw] leading-none text-white/[0.03] whitespace-nowrap">REENTRY STAFFING</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="h-9 w-9 grid place-items-center bg-[#FF5E1E] text-[#0B0F14]"><Anchor size={20} strokeWidth={2.5} /></span>
              <span className="font-display font-black uppercase tracking-tight text-lg">Reentry<span className="text-[#FF5E1E]">.</span>Staffing</span>
            </div>
            <p className="mt-4 text-sm text-[#8FA3B8] leading-relaxed">The Maritime Workforce Operating System. Recruitment · Training · Credentials · Access Readiness · Staffing · Career Development.</p>
          </div>

          <div>
            <div className="font-mono-tech text-[10px] tracking-[0.2em] text-[#FF5E1E] mb-4">PLATFORM</div>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.label}><a href={l.href} className="text-sm text-[#8FA3B8] hover:text-white transition-colors">{l.label}</a></li>
              ))}
            </ul>
          </div>

          <div>
            <div className="font-mono-tech text-[10px] tracking-[0.2em] text-[#FF5E1E] mb-4">TRAINING PARTNERS</div>
            <p className="text-sm text-[#8FA3B8] leading-relaxed">
              We integrate community colleges, apprenticeship programs, and workforce-development organizations. Advanced trades may be marked
              <span className="text-white"> "Available Through Training Partner."</span>
            </p>
            <p className="mt-3 text-[11px] text-[#6b7d92]">No formal partnership with any specific institution is implied unless authorized.</p>
          </div>

          <div>
            <div className="font-mono-tech text-[10px] tracking-[0.2em] text-[#FF5E1E] mb-4">24/7 STAFFING DISPATCH</div>
            <ul className="space-y-2.5 text-sm text-[#8FA3B8]">
              <li className="flex items-center gap-2"><Phone size={14} className="text-[#FF5E1E]" /> (757) 642-7170</li>
              <li className="flex items-center gap-2"><Mail size={14} className="text-[#FF5E1E]" /> reentrystaffing@yahoo.com</li>
            </ul>
            <a href="#apply" className="mt-4 inline-block font-display font-bold uppercase text-sm text-white border-b-2 border-[#FF5E1E] pb-0.5 hover:text-[#FF5E1E] transition-colors">Get Shipyard Ready →</a>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="font-mono-tech text-[10px] tracking-[0.15em] text-[#6b7d92]">© {new Date().getFullYear()} REENTRY STAFFING · ALL RIGHTS RESERVED</p>
          <p className="font-mono-tech text-[10px] tracking-[0.15em] text-[#6b7d92]">COMPLIANCE: OSHA 1915 · DoDI 5200.08 · DBIDS GUIDELINES</p>
        </div>
      </div>
    </footer>
  );
}
